import { render, staticRenderFns } from "./EditSize.vue?vue&type=template&id=51f4628c&"
import script from "./EditSize.vue?vue&type=script&lang=ts&"
export * from "./EditSize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports